import toastMixin from "./toastMixin";
const TIMEOUT = 3000;

export function successToast(message: string, timeout = TIMEOUT) {
    toastMixin.methods.successToast(message, timeout);
}

export function warningToast(message: string, timeout = TIMEOUT) {
    toastMixin.methods.warningToast(message, timeout);
}

export function errorToast(message, timeout = TIMEOUT) {
    toastMixin.methods.errorToast(message, timeout);
}
